import { Controller } from '@hotwired/stimulus'

// Turbo lazy-frames only fetch once when they become visible. After the first
// `turbo:frame-load`, each time the parent <details> opens we reload so content
// stays fresh (works with autosave_success skipping reload while collapsed).
export default class extends Controller {
  toggle () {
    if (!this.element.open) return

    const frames = [...this.element.querySelectorAll('turbo-frame[src]')]
    if (frames.length === 0) return

    if (this.element.dataset.lazyTurboFrameLoaded === 'true') {
      frames.forEach((tf) => {
        if (typeof tf.reload === 'function') tf.reload()
      })
      return
    }

    frames.forEach((tf) => {
      tf.addEventListener('turbo:frame-load', this.markLoaded, { once: true })
    })
  }

  markLoaded = () => {
    this.element.dataset.lazyTurboFrameLoaded = 'true'
  }
}
